import React from 'react';
import { Spinner } from '@/Components/shadcn';
import { useAssessmentsOverviewContext } from '../Contexts/AssessmentsOverviewContext';
import RecruitmentListItem from './RecruitmentList/RecruitmentListItem';
import EndOfListMessage from './EndOfListMessage';
import EmptyRecruitmentList from './EmptyRecruitmentList';
import { InfiniteScroll } from '@/Components/InfiniteScroll/InfiniteScroll';

function AssessmentsOverviewList(): React.JSX.Element {
    const { assessments, loading, totalAssessmentsCount, loadPageAsync } = useAssessmentsOverviewContext();

    if (loading && assessments.length === 0) {
        return (
            <div className="flex h-full items-center justify-center">
                <Spinner className="text-primary size-8" />
            </div>
        );
    }

    return (
        <>
            <InfiniteScroll
                next={async () => {
                    await loadPageAsync(assessments.length);
                }}
                hasMore={assessments.length < totalAssessmentsCount}
                endMessage={assessments.length > 0 && <EndOfListMessage />}
            >
                <div className="flex flex-col items-center justify-center gap-5">
                    {assessments.map((assessment) => (
                        <RecruitmentListItem key={assessment.id} recruitment={assessment} />
                    ))}
                </div>
            </InfiniteScroll>
            {!loading && assessments.length === 0 && <EmptyRecruitmentList />}
            <div className="min-h-30" />
        </>
    );
}

export default AssessmentsOverviewList;
